.attachment-document-sider-tabs {
    display: flex;
    flex-direction: column;
}

.attachment-document-sider-tabs > .ant-tabs-nav {
    flex: none;
}

.attachment-document-sider-tabs > .ant-tabs-content-holder,
.attachment-document-sider-tabs > .ant-tabs-content-holder > .ant-tabs-content,
.attachment-document-sider-tabs > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
    height: 100%;
    min-height: 0;
}

.attachment-document-sider-panel {
    box-sizing: border-box;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    padding: 0.75rem;
}
